import React, { useMemo } from 'react';

import { Grid, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { LoadingPage, RecordContextProvider, useRedirect } from 'react-admin';

import { useParams } from 'react-router-dom';

import useEntityData from '../../../../../../hooks/useEntityData';

import { AdverseMediaMatches } from '../../../../../../utilities/schemas/adverseMediaMatches';

import actions from '../../../../../../constants/actions';

import AdverseMediaMatchInformation from './AdverseMediaMatchInformation';
import AdverseMediaAbout from './AdverseMediaAbout';
import AdverseMediaNationalIdentifiers from './AdverseMediaNationalIdentifiers';
import AdverseMediaImages from './AdverseMediaImages';
import AdverseMediaSources from './AdverseMediaSources';
import AdverseMediaRelatedEntities from './AdverseMediaRelatedEntities';
import AdverseMediaMedias from './AdverseMediaMedias';

const GoBackButton = () => {
  const redirect = useRedirect();

  return (
    <IconButton onClick={() => { redirect('..'); }} size="small">
      <ArrowBackIosIcon color="inherit" fontSize="medium" />
    </IconButton>
  );
};

const AdverseMediaDetails = () => {
  const {
    data,
    isLoading,
  } = useEntityData<AdverseMediaMatches>({
    source: 'adverse-media',
    getAction: actions.INDIVIDUAL_GET_ADVERSE_MEDIA,
  });

  const { adverseMediaId } = useParams();

  const currentSanction = useMemo(
    () => data?.potentialMatches.find((match) => match._id === adverseMediaId),
    [data, adverseMediaId],
  );

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <RecordContextProvider value={{ ...currentSanction, providerName: data?.providerName }}>
      <Grid container spacing={4}>
        <Grid size={12}>
          <GoBackButton />
        </Grid>
        <Grid size={12}>
          <Grid container spacing={6}>
            <Grid size={12}>
              <AdverseMediaMatchInformation />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <AdverseMediaAbout />
                </Grid>
                <Grid size={12}>
                  <AdverseMediaNationalIdentifiers />
                </Grid>
                <Grid size={12}>
                  <AdverseMediaImages />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <AdverseMediaMedias />
                </Grid>
                <Grid size={12}>
                  <AdverseMediaRelatedEntities />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <AdverseMediaSources />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </RecordContextProvider>
  );
};

export default AdverseMediaDetails;
